(function () {
    'use strict';

    angular
        .module('app')
        .factory('ConvertClientObject', ConvertClientObject);

    ConvertClientObject.$inject = ['$http', '$cookieStore', '$rootScope', '$timeout', 'apiHost', '$q'];
    function ConvertClientObject($http, $cookieStore, $rootScope, $timeout, apiHost, $q) {
        var ClientObject = {};

        ClientObject.ConvertUserInformation = ConvertUserInformation;
        ClientObject.Empty = {
            "fields": {
                    "seriesAndNumber": '',
                    "issuedBy": null,
                    "issuedDate": "0001-01-01T00:00:00",
                    "divisionCode": '',
                    "regAddressRegDate": "0001-01-01T00:00:00",
                    "regAddressResidenceId": 0,
                    "liveAddressRegDate": "0001-01-01T00:00:00",
                    "liveAddressResidenceId": 0,
                    "anketaFields": {
                        "NoInsurancesReason": null,
                        "PrevPassportSeriesAndNumber": null,
                        "Surname": null,
                        "Name": null,
                        "Patronymic": null,
                        "BirthDay": null,
                        "IsRussiaBirthCountry": true,
                        "BirthRegion": null,
                        "BirthPlace": null,
                        "Sex": true,
                        "IsIPDL": null,
                        "Citizenship": 1,
                        "MaritalStatus": null,
                        "ChildrenCount": null,
                        "DependantsCount": 0, //null выводило в поле null
                        "EducationId": null,
                        "UniversityName": null,
                        "GraduationYear": null,
                        "MothersMaidenName": null,
                        "PrevSurname": null,
                        "PrevName": null,
                        "PrevPatronymic": null,
                        "Email": "",
                        "InhabitantsCount": null,
                        "EmergencyPhone": null,
                        "HomePhone": null,
                        "MobilePhone": null,
                        "WorkPhone": null,
                        "RelativeType": 14,
                        "RelativeSurname": null,
                        "RelativeName": null,
                        "RelativePatronymic": null,
                        "RelativePhone": null,
                        "Employer": null,
                        "CompanyType": null,
                        "Position": null,
                        "PositionFromList": null,
                        "EmploymentType": null,
                        "IndustryType": null,
                        "OccupationArea": null,
                        "EmployeedSience": null,
                        "PrevExperience": null,
                        "Experience": null,
                        "Profession": null,
                        "WorkersCount": null,
                        "MarriageDate": null,
                        "SpouseSurname": null,
                        "SpouseName": null,
                        "SpousePatronymic": null,
                        "SpouseBirthDay": null,
                        "SpouseEmployer": null,
                        "SpouseProfession": null,
                        "SpouseSocialStatus": null,
                        "IsHasRealEstate": null,
                        "IsHasHouse": null,
                        "IsHasApartment": null,
                        "IsHasCountryHouse": null,
                        "IsHasLand": null,
                        "IsHasGarage": null,
                        "IsHasOthers": null,
                        "AverageMonthlyIncome": null,
                        "SpouseIncome": 0,
                        "ExtraIncome": 0,
                        "OtherCredits": 1,
                        "MonthlyCreditPayment": 0,
                        "UnsettledCreditPayments": 0,
                        "MortgagePayments": 0,
                        "CompulsoryDocumentPayments": 0,
                        "OtherMonthlyCreditLoanPayments": 0,
                        "FamilyOtherMonthlyCreditLoanPayments": 0,
                        "HasUnsettledDebts": false,
                        "IsGoodVisualEstimation": true,
                        "IsFraud": false,
                        "FraudComments": null,
                        "IsSuspiciousBehavior": false,
                        "SuspiciousBehaviorComments": null,
                        "IsSuspiciousLoan": false,
                        "SuspiciousLoanComments": null,
                        "IsConflictingPersonalData": false,
                        "ConflictingPersonalDataComments": null,
                        "IsExternalInfluence": false,
                        "ExternalInfluenceComments": null,
                        "IsSuspiciousPassport": false,
                        "SuspiciousPassportComments": null,
                        "IsSuspiciousAdditionalDocs": false,
                        "SuspiciousAdditionalDocsComments": null,
                        "IsSuspiciousFinanceDocs": null,
                        "SuspiciousFinanceDocsComments": null,
                        "IsDrugs": false,
                        "DrugsComments": null,
                        "IsFalseSocialStatus": false,
                        "FalseSocialStatusComments": null,
                        "IsAlcohol": false,
                        "AlcoholComments": null,
                        "IsInvalid": false,
                        "InvalidComments": null,
                        "IsHasVehicle": false,
                        "VehicleMarkModel": null,
                        "VehicleYear": null,
                        "VehicleBuyingProcess": null,
                        "VehicleRegNumber": null,
                        "MonthlyPayment": null,
                        "IsSameRegAndLiveAddr": true,
                        "DocumentType": null,
                        "SecondRelativeName":null,
                        "SecondRelativeSurname":null,
                        "SecondRelativePatronymic":null,
                        "CountWorking": 0,
                        "AgeOfCompany": 0,
                        "INN": null

                    }
                },
            "addresses": []
        };


        function reformatedViewPhoneForClient(string){
            return '+7 '+string.substr(0,3) + ' ' + string.substr(3,3) + ' '  + string.substr(6,4);
        }



        function ConvertUserInformation(obj, noEmptyClient) {
            var deferred = $q.defer();
            var objSend = {};
            objSend.client = {
                "PersonalData": {
                    "SendSearchCustomer": false,
                    "FIOServices": {
                        "fio":((obj.fields.anketaFields.Surname)?obj.fields.anketaFields.Surname:'') + ' ' + ((obj.fields.anketaFields.Name)?obj.fields.anketaFields.Name:'') +' '+ ((obj.fields.anketaFields.Patronymic)?obj.fields.anketaFields.Patronymic:''),
                        "lastName":obj.fields.anketaFields.Surname,
                        "firstName":obj.fields.anketaFields.Name,
                        "middleName":(obj.fields.anketaFields.Patronymic)?obj.fields.anketaFields.Patronymic:'',
                        "gender":(obj.fields.anketaFields.Sex)?'MALE': ((obj.fields.anketaFields.Sex == null) ? 'UNKNOWN': 'FEMALE')},
                    "DataBirthday": (obj.fields.anketaFields.BirthDay == '0001-01-01T00:00:00')?'':obj.fields.anketaFields.BirthDay,
                    "Income": obj.fields.anketaFields.AverageMonthlyIncome,
                    "Employment": {
                        "code": obj.fields.anketaFields.EmploymentType
                    },
                    "Gender": (obj.fields.anketaFields.Sex)?'man':'woman',
                    "CodeRefuse": {
                        "code": obj.codeRefuse
                    },
                    "LastName": obj.fields.anketaFields.Surname,
                    "FirstName": obj.fields.anketaFields.Name,
                    "MiddleName": obj.fields.anketaFields.Patronymic,
                    "PhoneFriend": (obj.fields.anketaFields.RelativePhone)?reformatedViewPhoneForClient(obj.fields.anketaFields.RelativePhone):'',
                    "Relation": {
                        "code": obj.fields.anketaFields.RelativeType
                    },
                    "Education": {
                        "code": obj.fields.anketaFields.EducationId
                    },
                    "SecretWord": obj.fields.anketaFields.MothersMaidenName,
                    "MaritalStatus": {
                        "code": obj.fields.anketaFields.MaritalStatus
                    },
                    "SpouseIncome": (obj.fields.anketaFields.SpouseIncome == 0)?'':obj.fields.anketaFields.SpouseIncome,
                    "OldLastName": obj.fields.anketaFields.PrevSurname,
                    "CountChildren": obj.fields.anketaFields.ChildrenCount,
                    "CountDependents": parseInt(obj.fields.anketaFields.DependantsCount ? obj.fields.anketaFields.DependantsCount: 0),
                    "WeddingDate": (obj.fields.anketaFields.MarriageDate == '0001-01-01T00:00:00')?'':obj.fields.anketaFields.MarriageDate,
                    "SpouseBirthDay": (obj.fields.anketaFields.SpouseBirthDay == '0001-01-01T00:00:00')?'':obj.fields.anketaFields.SpouseBirthDay,
                    "SpouseEmployer":  {"Value":obj.fields.anketaFields.SpouseEmployer, "ValueAddress": obj.fields.anketaFields.SpouseEmployer},
                    "SpouseProfession": {
                        "code": obj.fields.anketaFields.SpouseProfession
                    },
                    "SpouseFIOServices": (obj.fields.anketaFields.SpouseSurname)?{
                        "fio":obj.fields.anketaFields.SpouseSurname + ' ' + obj.fields.anketaFields.SpouseName +' '+ obj.fields.anketaFields.SpousePatronymic,
                        "lastName":obj.fields.anketaFields.SpouseSurname,"firstName":obj.fields.anketaFields.SpouseName,
                        "middleName":obj.fields.anketaFields.SpousePatronymic,
                        "gender":'MALE'}:'',
                    "FIOFriend": (obj.fields.anketaFields.RelativeSurname)?{
                        "fio":obj.fields.anketaFields.RelativeSurname + ' ' + obj.fields.anketaFields.RelativeName +' '+ obj.fields.anketaFields.RelativePatronymic,
                        "lastName":obj.fields.anketaFields.RelativeSurname,"firstName":obj.fields.anketaFields.RelativeName,
                        "middleName":obj.fields.anketaFields.RelativePatronymic,
                        "gender":'MALE'}:'',
                    "SecondRelativePhone": (obj.fields.anketaFields.SecondRelativePhone)?reformatedViewPhoneForClient(obj.fields.anketaFields.SecondRelativePhone):'',
                    "FIOSecondRelative": (obj.fields.anketaFields.SecondRelativeName)?{
                        "fio":obj.fields.anketaFields.SecondRelativeName + ' ' + obj.fields.anketaFields.SecondRelativeSurname +' '+ obj.fields.anketaFields.SecondRelativePatronymic,
                        "lastName":obj.fields.anketaFields.SecondRelativeSurname,"firstName":obj.fields.anketaFields.SecondRelativeName,
                        "middleName":obj.fields.anketaFields.SecondRelativePatronymic,
                        "gender":'MALE'}:'',
                    "EmpoymentCombo":
                        {"Position": obj.fields.anketaFields.Position,
                            "EmploymentType": obj.fields.anketaFields.EmploymentType,
                            "PositionCode": null,
                            "PositionFromList": obj.fields.anketaFields.PositionFromList
                        }


                },
                "PersonalContacts": {
                    "Email": obj.fields.anketaFields.Email,
                    "Phone": (obj.fields.anketaFields.MobilePhone)?reformatedViewPhoneForClient(obj.fields.anketaFields.MobilePhone):'',
                    "Comment": obj.fields.comment,
                    "SellerPhone":(obj.fields.sellerPhone)?reformatedViewPhoneForClient(obj.fields.sellerPhone): ''
                },
                "Addresses": {
                    "IsSameRegAndLiveAddr":obj.fields.anketaFields.IsSameRegAndLiveAddr,
                    "adresses": obj.addresses,
                    "AdressSameFactAndRegistration": true,
                    "StatusRegistration": {
                        "code":obj.fields.regAddressResidenceId
                    },
                    "StatusFactRegistration": {
                        "code":obj.fields.liveAddressResidenceId
                    },
                    "regAddressRegDate": (obj.fields.regAddressRegDate == '0001-01-01T00:00:00')?'':obj.fields.regAddressRegDate,
                    "InhabitantsCount": parseInt(obj.fields.anketaFields.InhabitantsCount),
                    "HomePhone": (obj.fields.anketaFields.HomePhone)?reformatedViewPhoneForClient(obj.fields.anketaFields.HomePhone):'',
                    "EmergencyPhone": (obj.fields.anketaFields.EmergencyPhone)?reformatedViewPhoneForClient(obj.fields.anketaFields.EmergencyPhone):'',
                    "HomePhoneRelativePhone": (obj.fields.anketaFields.RelativePhone)?reformatedViewPhoneForClient(obj.fields.anketaFields.RelativePhone):'',
                    "LiveDataRegistration":(obj.fields.liveAddressRegDate == '0001-01-01T00:00:00')?'':(obj.fields.liveAddressRegDate.substr(5,2) +'-' +obj.fields.liveAddressRegDate.substr(0,4))
                },
                "Pasport": {
                    "DataPassport": (obj.fields.issuedDate == '0001-01-01T00:00:00')?'':obj.fields.issuedDate,
                    "PassportSerieAndNumber": obj.fields.seriesAndNumber,
                    "IssuedBy": obj.fields.issuedBy,
                    "passportSpecCode": obj.fields.divisionCode,
                    "PlaceBorn": obj.fields.anketaFields.BirthPlace,
                    "OldPassport": obj.fields.PrevPassportSeriesAndNumber
                },
                "Noresident": {
                    //гражданство
                    "Citizenship": {"code":obj.fields.anketaFields.Citizenship},
                    //Документ
                    "DocumentType": {"code":obj.fields.anketaFields.DocumentType},
                    //Номер нац паспорта
                    "NP_Number": obj.fields.NP_Number,
                    //дата выдачи нац паспорта
                    "NP_IssuedDate":(obj.fields.NP_IssuedDate == '0001-01-01T00:00:00')?'': obj.fields.NP_IssuedDate,
                    //кем выдан паспорт
                    "NP_IssuedBy": obj.fields.NP_IssuedBy,
                    "NP_ExpirationDate": (obj.fields.NP_ExpirationDate == '0001-01-01T00:00:00')?'': obj.fields.NP_ExpirationDate,
                    //Номер принятия решения
                    "TRP_DecisionNumber": obj.fields.TRP_DecisionNumber,
                    //Дата принятия решения
                    "TRP_DecisionDate":(obj.fields.TRP_DecisionDate == '0001-01-01T00:00:00')?'': obj.fields.TRP_DecisionDate,
                    //Срок действия решения
                    "TRP_ExpirationDate":(obj.fields.TRP_ExpirationDate == '0001-01-01T00:00:00')?'': obj.fields.TRP_ExpirationDate,
                    "TRP_IssuedBy": obj.fields.TRP_IssuedBy,
                    //Номер ВНЖ
                    "RP_Number": obj.fields.RP_Number,
                    //дата выдачи ВНЖ
                    "RP_IssuedDate":(obj.fields.RP_IssuedDate == '0001-01-01T00:00:00')?'': obj.fields.RP_IssuedDate,
                    //кем выдан ВНЖ
                    "RP_IssuedBy": obj.fields.RP_IssuedBy,
                    "RP_ExpirationDate":(obj.fields.RP_ExpirationDate == '0001-01-01T00:00:00')?'': obj.fields.RP_ExpirationDate,
                    "RP_DecisionNumber": obj.fields.RP_DecisionNumber,
                    "RP_DecisionDate":(obj.fields.RP_DecisionDate == '0001-01-01T00:00:00')?'': obj.fields.RP_DecisionDate,
                    //ИНН
                    "INN": obj.fields.anketaFields.INN,
                    //родной язык
                    "NativeLanguage":{
                        "code": obj.fields.anketaFields.NativeLanguage
                    },
                    "RelativeType": {
                        "code": obj.fields.anketaFields.RelativeType
                    },
                    "SecondRelativeType": {
                        "code": obj.fields.anketaFields.SecondRelativeType
                    },
                    "NativePhone": obj.fields.anketaFields.HomePhone ? obj.fields.anketaFields.HomePhone:'',
                    "MonthlyPayment":  obj.fields.anketaFields.MonthlyPayment ? obj.fields.anketaFields.MonthlyPayment : ''
                },
                "Working": {
                    "Organization": {"Value":obj.fields.anketaFields.Employer, "ValueAddress":obj.fields.anketaFields.Employer },
                    "Post": obj.fields.anketaFields.Position,
                    "EmployeedSience": obj.fields.anketaFields.EmployeedSience,
                    "PostPhone": (obj.fields.anketaFields.WorkPhone)?reformatedViewPhoneForClient(obj.fields.anketaFields.WorkPhone):'',
                    "WorkExperience": obj.fields.anketaFields.Experience,
                    "WorkExperienceLast": "",
                    "TypeOrganization": {
                        "code": obj.fields.anketaFields.CompanyType
                    },
                    "TypeWorkOrganization": {
                        "code": obj.fields.anketaFields.IndustryType
                    },
                    "TypeActivity": {
                        "code": obj.fields.anketaFields.OccupationArea
                    },
                    "FIOBoss": (obj.fields.anketaFields.SecondRelativeName)?{
                        "fio":obj.fields.anketaFields.SecondRelativeName + ' ' + obj.fields.anketaFields.SecondRelativeSurname +' '+ obj.fields.anketaFields.SecondRelativePatronymic,
                        "lastName":obj.fields.anketaFields.SecondRelativeSurname,"firstName":obj.fields.anketaFields.SecondRelativeName,
                        "middleName":obj.fields.anketaFields.SecondRelativePatronymic,
                        "gender":'MALE'}:'',
                    // "LevelActivity": {
                    //     "code": obj.fields.anketaFields.PositionFromList
                    // }
                    "CountWorking": obj.fields.anketaFields.CountWorking,
                    "AgeOfCompany":obj.fields.anketaFields.AgeOfCompany,
                    "INN": obj.fields.anketaFields.INN
                },
                "Action":{
                    "CreditType": obj.fields.anketaFields.CreditType,
                    "InitPay": obj.fields.anketaFields.InitPay,
                    "Term": obj.fields.anketaFields.Term,
                    "action":obj.actions
                },
                "AutoDoc": {
                    "DataAutoDoc": "",
                    "AutoDocSerieAndNumber": "",
                    "AutoDocIssuedBy": "",
                    "AutoDocExperience": "",
                    "AutoDocCategory": "",
                    "AutoDocMachine": "",
                    "AutoDocMark":obj.fields.anketaFields.VehicleMarkModel,
                    "AutoDocMachineNumber":obj.fields.anketaFields.VehicleRegNumber,
                    "AutoDocMachineDate":(obj.fields.anketaFields.VehicleYear == '0001-01-01T00:00:00')?'':obj.fields.anketaFields.VehicleYear

                }
            };
            if(noEmptyClient){
                var emptyGoods =  [
                    {
                        "sendGoodName": "",
                        "sendGoodPrice": '',
                        "sendGoodsCategories": {
                            "code": ""
                        },
                        "sendGoodsType": {
                            "code": ""
                        }
                    }
                ];
                objSend.goods = (obj.goods.length == 0)?emptyGoods:obj.goods;
                objSend.goods.isEmpty = (obj.goods.length == 0)?true:false;
                objSend.action = obj.actions;
                objSend.document ={};
                objSend.attaches = (obj.attaches && obj.attaches.length == 0)?[]:obj.attaches;
                objSend.secondpart = obj.secondPartInfo;

                if(obj.secondPartInfo){
                    sessionStorage.setItem("ApplicationId", obj.secondPartInfo.posApplicationId);
                    sessionStorage.setItem("bankApplicationId", obj.secondPartInfo.bankApplicationId);
                }

            }



            deferred.resolve(objSend);
            return deferred.promise;
        }
        


        return ClientObject;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('GetUserInformation', GetUserInformation);

    GetUserInformation.$inject = ['$http', '$location', '$rootScope', '$timeout', 'apiHost', '$q'];
    function GetUserInformation($http, $location, $rootScope, $timeout, apiHost, $q) {
        var informationServices = {};

        informationServices.allUserInformation = allUserInformation;
        informationServices.DownloadInformation = DownloadInformation;
        informationServices.GetScriptInfo = GetScriptInfo;
        informationServices.UserInformation = null;

        var deferred = $q.defer();

        var req = {};

        var reqFull = {
            method: 'POST',
            url: apiHost.url + 'User/AllInformationAboutUser',
            headers: {
                Authorization :localStorage.getItem("token")
            },
            data: {"token": localStorage.getItem("token")}
        };

        var reqShort = {
            method: 'POST',
            url: apiHost.url + 'User/AllInformationAboutUserWithApp',
            headers: {
                Authorization :localStorage.getItem("token")
            },
            data: {"token": localStorage.getItem("token"), "appId": sessionStorage.getItem("appId")}
        };

        if(sessionStorage.getItem("shortapplication") == 1 || sessionStorage.getItem("shortapplication") == 3) req = reqShort;
        else req = reqFull;

        $http(req).then(
            function (success) {
                informationServices.UserInformation = success.data.value;

                if(!success.data.isSuccess && $location.url() == '/'){
                    $location.path('/login');
                }
                else{
                    if(sessionStorage.getItem("shortapplication") != 2){
                        if(success.data.tempApplicationId != undefined) {sessionStorage.setItem("tempApplicationId", success.data.tempApplicationId);}
                        else{sessionStorage.setItem("tempApplicationId", 0)}
                    }

                    deferred.resolve(informationServices.UserInformation);
                }

            },
            function (error) {
                $location.path('/login');
                deferred.reject(error);
            }
        );

        function allUserInformation() {
            if (informationServices.UserInformation !== null) {
                deferred.resolve(informationServices.UserInformation);
            }
            return deferred.promise;
        }

        function DownloadInformation() {
            var reqReload = {
                method: 'POST',
                url: apiHost.url + 'User/AllInformationAboutUser',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"token": localStorage.getItem("token")}
            };

            var deferred = $q.defer();
            $http(reqReload).then(
                function (success) {
                    informationServices.UserInformation = success.data.value;
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;


        }

        function GetScriptInfo(typeScript) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: 'https://vsegda-da.credit/Services/VsegdaDaService/api/User/ScriptInfo',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"token": '5D450E59-E110-45F8-885C-7111F9CE6F66', "typeScript":typeScript}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;


        }

        return informationServices;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('GetandSendInfoKO', GetandSendInfoKO);

    GetandSendInfoKO.$inject = ['$http', '$cookieStore', '$rootScope', '$timeout', 'apiHost', '$q'];
    function GetandSendInfoKO($http, $cookieStore, $rootScope, $timeout, apiHost, $q) {
        var informationServices = {};

        var token = localStorage.getItem("token");
        /** Обогащение и аунтентификация*/
        $http({
            method: "post",
            url: "/ip.php",
            data: {},
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (data) {
            /!*обогащение*!/
            localStorage.setItem("ip", data.data.ip);
            localStorage.setItem("user_agent", data.data.user_agent);
        });
        informationServices.getAllActionOfBanksWithParam = getAllActionOfBanksWithParam;
        informationServices.SaveGoods = SaveGoods;
        informationServices.PreCalculationInsurance = PreCalculationInsurance;
        informationServices.SaveActions = SaveActions;
        informationServices.SaveAnket = SaveAnket;
        informationServices.GetListtempApplication = GetListtempApplication;
        informationServices.OpenDraft = OpenDraft;
        informationServices.GetAntiTurn = GetAntiTurn;
        informationServices.SaveAttach = SaveAttach;
        informationServices.SaveAttachTest = SaveAttachTest;
        informationServices.SaveAddress = SaveAddress;
        informationServices.SendApplication = SendApplication;
        informationServices.SendApplicationShort = SendApplicationShort;
        informationServices.ContinueShortForm = ContinueShortForm;
        informationServices.StatusApplicationsList = StatusApplicationsList;
        informationServices.SendNextBank = SendNextBank;
        informationServices.CreateInsurancePolis = CreateInsurancePolis;

        informationServices.SignApplication = SignApplication;
        informationServices.SendAuthorizationCode = SendAuthorizationCode;
        informationServices.SignInsurancePolis = SignInsurancePolis;
        informationServices.SignApplicationSMS = SignApplicationSMS;
        informationServices.CheckShortFormStatus = CheckShortFormStatus;
        informationServices.CancelApplication = CancelApplication;
        informationServices.AnnulInsurancePolis = AnnulInsurancePolis;

        /*Statistics*/
        informationServices.UncompletedApplications=UncompletedApplications;
        informationServices.LoadStatistics = LoadStatistics;
        informationServices.SearchStatistics = SearchStatistics;
        informationServices.StatisticForApp = StatisticForApp;
        informationServices.SetApplicationApproval = SetApplicationApproval;
        informationServices.SetApplicationApprovalForSMS = SetApplicationApprovalForSMS;
        informationServices.ApplicationBankStatus = ApplicationBankStatus;
        informationServices.ApplicationInsuranceStatus = ApplicationInsuranceStatus;
        informationServices.ConfirmDecisionBank = ConfirmDecisionBank;
        informationServices.NeedScansApplications=NeedScansApplications;

        /*Scans*/
        informationServices.CheckScans = CheckScans;
        informationServices.SendScans = SendScans;
        informationServices.SaveScan = SaveScan;
        informationServices.SendReconciliationActScanCEB = SendReconciliationActScanCEB;

        /*Отправка второго блока*/
        informationServices.OpenSecondPart = OpenSecondPart;
        informationServices.DeactivateSecondPart = DeactivateSecondPart;
        /*Проверка наличия фото*/
        informationServices.CheckPhotoDraft = CheckPhotoDraft;
        informationServices.SendShortApplication = SendShortApplication;

        /*Обогащение*/
        informationServices.SearchCustomer = SearchCustomer;
        informationServices.ClearDraft = ClearDraft;

        /*Карта совесть  - киви*/
        informationServices.CreateCreditCardDraft = CreateCreditCardDraft;
        informationServices.SaveAuthorizationCode = SaveAuthorizationCode;

        /**Информация Аккредитация*/
        informationServices.CheckAccreditation = CheckAccreditation;
        informationServices.AccreditationInfo = AccreditationInfo;
        informationServices.SendAccreditationResult = SendAccreditationResult;

        /**Фото по мобильному*/
        informationServices.SendLinkForPhoto = SendLinkForPhoto;
        informationServices.ChangePhoneNumberSendMessage  = ChangePhoneNumberSendMessage ;
        informationServices.ChangePhoneNumberSendCode  = ChangePhoneNumberSendCode;

        /**отсылка и проверка СМС кода для ПЛ*/
        informationServices.SendSMSforSignPL = SendSMSforSignPL;
        informationServices.CheckSMSforSignPL = CheckSMSforSignPL;
        informationServices.SMSSignApplication=SMSSignApplication;

        /**отсылка и проверка СМС кода для всех банков*/
        informationServices.SendSMSforSign = SendSMSforSign;
        informationServices.CheckSMSforSign = CheckSMSforSign;

        /**Отправка заяки на доп подписки*/
        informationServices.SendSubscribe = SendSubscribe;
        /**Аннулирование заявки на доп подписку*/
        informationServices.AnnulSubscribe=AnnulSubscribe;
        /**Получение информации по заявке на доп подписку*/
        informationServices.ApplicationSubscribeStatus=ApplicationSubscribeStatus;

        function SendLinkForPhoto(tempApplicationId, mobilePhone) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/SendLinkForPhoto',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "tempApplicationId": tempApplicationId,
                    "mobilePhone": mobilePhone
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function CreateCreditCardDraft(userId, bankId, tempApplicationId, bankList) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/CreateCreditCardDraft',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "userId": userId,
                    "bankId": bankId,
                    "tempApplicationId": tempApplicationId,
                    "bankList": bankList
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SendAccreditationResult(userId, accreditationInfo) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Accreditation/SendAccreditation',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "accreditationInfo": accreditationInfo,
                    "userId": userId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function AccreditationInfo(userId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Accreditation/AccreditationInfo',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "userId": userId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function CheckAccreditation(userId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Accreditation/CheckAccreditation',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "userId": userId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function ClearDraft(tempApplicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/ClearDraft',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "tempApplicationId": tempApplicationId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SendShortApplication(tempApplicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/SendShortApplication',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "tempApplicationId": tempApplicationId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function getAllActionOfBanksWithParam(
            organizationId,
            shopId,
            orderSum,
            typeCredit,
            sendInitialPayment,
            sendPeriodCredit,
            sendInsurance,
            sendSmsPackage,
            sendInsuranceBox,
            tempApplicationId,
            notResident,
            sendIviBox,
            sendSumGoodsWithoutDiscount
            ) {
            var deferred = $q.defer();

            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/PreCalculation',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "organizationId": organizationId,
                    "shopId": shopId,
                    "isCredit": typeCredit,
                    "hasSMSInform": sendSmsPackage,
                    "insuranceId": sendInsurance,
                    "boxInsuranceId": sendInsuranceBox,
                    "term": parseInt(sendPeriodCredit),
                    "initialPayment": parseInt(sendInitialPayment),
                    "sumGoods": parseInt(orderSum),
                    "tempApplicationId": tempApplicationId,
                    "showNonResidentActions": notResident,
                    "subscriptionServiceId":  sendIviBox,
                    "sumGoodsWithoutDiscount": sendSumGoodsWithoutDiscount
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );


            return deferred.promise;
        }

        function SaveGoods(goods, userid, tempApplicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/SaveGoods',
                headers: { Authorization :localStorage.getItem("token")},
                data: {
                    "tempApplicationId": (tempApplicationId)?tempApplicationId:0,
                    "userId": userid,
                    "goods": goods
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function PreCalculationInsurance(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Insurance/PreCalculationInsurance',
                headers: { Authorization :localStorage.getItem("token")},
                data: data
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SaveActions(action, tempApplicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/SaveActions',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "tempApplicationId": (tempApplicationId)?tempApplicationId:0,
                    "actions": action
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SaveAnket(tempApplicationId, valueArr) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/SaveAnket',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "tempApplicationId": (tempApplicationId)?tempApplicationId:0,
                    "draftFields": valueArr
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function GetListtempApplication(id, draftType) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/ShowDrafts',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"userId": id, "draftType":draftType} // 1 - полная анкета, 2 - короткая
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function OpenDraft(tempApplicationId, isCreditCard, needPhoto, creditCardBankId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/OpenDraft',
                headers: {
					Authorization :localStorage.getItem("token")
				},
                data: {
                    "tempApplicationId": tempApplicationId,
                    "isCreditCard": isCreditCard,
                    "needPhoto": true,
                    'bankList': creditCardBankId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function GetAntiTurn(token, Surname, Name, Patronymic, clientPhone, employeePhone) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/SendAntiQueueApplication',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token":token,
                    "Surname":Surname,
                    "Name":Name,
                    "Patronymic":Patronymic,
                    "clientPhone":clientPhone,
                    "employeePhone":employeePhone
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SaveAttachTest(tempApplicationId,attach) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: 'https://vsegda-da.credit/Services/VsegdaDaServiceTest/api/Draft/SaveAttach',
                headers: { Authorization :localStorage.getItem("token")},
                data: {
                    "tempApplicationId": tempApplicationId,
                    "attach": attach
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SaveAttach(tempApplicationId,attach) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/SaveAttach',
                headers: { Authorization :localStorage.getItem("token")},
                data: {
                    "tempApplicationId": tempApplicationId,
                    "attach": attach
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SaveAddress(tempApplicationId,address) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/SaveAddress',
                headers: { Authorization :localStorage.getItem("token")},
                data: {
                    "tempApplicationId": tempApplicationId,
                    "address": address
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SendApplication(tempApplicationId, token, appId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SendApplication',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "tempApplicationId": tempApplicationId,
                    "token": token,
                    "appId":appId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SendApplicationShort(tempApplicationId, applicationId, token, shopCode, codeUBL) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SendShortApplication',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                timeout : 60000,
                data: {
                    "tempApplicationId": tempApplicationId,
                    "appId":applicationId,
                    "token": token
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function ContinueShortForm(applicationId, bankApplicationId, shopCode, codeUBL) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SendApplicationSecondPart',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankApplicationId
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function StatusApplicationsList(token, dtStart, kdNumber, clientfio, passport, posapplicationID, appstatus) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/ApplicationsList',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "dtStart": dtStart,
                    "kdNumber": kdNumber,
                    "clientfio": clientfio,
                    "passport": passport,
                    "posapplicationID": posapplicationID,
                    "appstatus":appstatus
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function ConfirmDecisionBank(applicationId, bankId, decisionId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/ConfirmDecisionBank',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankId,
                    "decisionId": decisionId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }



        function ApplicationBankStatus(token, applicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/ApplicationBankStatus',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "applicationId": applicationId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function ApplicationInsuranceStatus(token, applicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Insurance/ApplicationInsuranceStatus',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "applicationId": applicationId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function ApplicationSubscribeStatus(token, applicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/ApplicationSubscriptionServiceStatus',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "applicationId": applicationId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SetApplicationApproval(token, applicationId, bankId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SetApplicationApproval',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "applicationId":applicationId,
                    "bankId":bankId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function SetApplicationApprovalForSMS(token, applicationId, bankId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SetApplicationApprovalForSMS',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "applicationId":applicationId,
                    "bankId":bankId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function SendNextBank(applicationId, bankId, reason) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/SendNextBank',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankId,
                    "reason":reason
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function CancelApplication(applicationId, bankId, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/CancelApplication',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function AnnulInsurancePolis(applicationId, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Insurance/AnnulInsurancePolis',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function AnnulSubscribe(applicationId, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/CancelSubscriptionService',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }



        function SignApplication(applicationId, bankId, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SignApplication',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SignInsurancePolis(applicationId, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Insurance/SignInsurancePolis',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function SignApplicationSMS(bankApplicationId, codeUBL) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/POSExpress/SMSSigning',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "bankApplicationId": bankApplicationId,
                    "codeUBL": codeUBL
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function CheckShortFormStatus(applicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/CheckShortApplicationStatus',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function LoadStatistics(token, startDate, endDate) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Statistics/LoadStatistics',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "startDate": startDate,
                    "endDate": endDate
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SearchStatistics(token, startDate, endDate, clientFIO, appId, bankId, statusName,checkScan) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Statistics/SearchStatistics',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "startDate": startDate,
                    "endDate": endDate,
                    "clientFIO": clientFIO,
                    "appId": appId,
                    "bankId": bankId,
                    "statusName": statusName,
                    "needScansApplications":checkScan
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function StatisticForApp(token, appId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Statistics/StatisticForApp',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "appId": appId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function CheckPhotoDraft(tempApplicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Draft/CheckPhotoDraft',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "tempApplicationId": tempApplicationId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function OpenSecondPart(applicationId, bankId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/OpenSecondPart',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function DeactivateSecondPart(applicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/DeactivateSecondPart',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function CheckScans(applicationId, bankId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Scans/CheckScans',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId":bankId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SaveScan(applicationId, bankId, scan) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Scans/SaveScan',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId":bankId,
                    "scan":scan
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SendScans(applicationId, bankId, isStreetDBO) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Scans/SendScans',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "isStreetDBO":isStreetDBO,
                    "bankId":bankId
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SaveAuthorizationCode(authorizationCode, applicationId, bankId, time) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SaveAuthorizationCode',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "authorizationCode":authorizationCode,
                    "applicationId": applicationId,
                    "bankId":bankId,
                    "cardExpire": time,
                    "token": localStorage.getItem("token")
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function SendReconciliationActScanCEB(scan) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Scans/SendReconciliationActScanCEB',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": token,
                    "scan":scan
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function SearchCustomer(passport, tempApplicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/SearchCustomer',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token": localStorage.getItem("token"),
                    "passport": passport,
                    "ipAddress": localStorage.getItem("ip"),
                    "browser": localStorage.getItem("user_agent"),
                    "tempApplicationId":tempApplicationId
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                    }
                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }


        function ContinueApplicationHKFB(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/ContinueApplicationHKFB',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: data
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function CreditCardInfo(applicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/CreditCardInfo',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"applicationId":applicationId}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function BankOfficesList(value) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/BankOfficesList',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"value":value}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SetCreditCardDelivery(applicationId, deliveryType, officeCode, addressType, address ) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/SetCreditCardDelivery',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId":applicationId,
                        "deliveryType":deliveryType,
                        "officeCode":officeCode,
                        "addressType":addressType,
                        "address":address
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function ConfirmCreditCardOffer(applicationId, creditCardOfferId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/ConfirmCreditCardOffer',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"applicationId":applicationId, "creditCardOfferId":creditCardOfferId}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function SetCreditCardNumber(creditCardNumber, applicationId, cardId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/SetCreditCardNumber',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"applicationId":applicationId, "creditCardNumber":creditCardNumber, "creditCardOfferId":cardId}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function RefuseCreditCard(applicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/RefuseCreditCard',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"applicationId":applicationId}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function SignCreditCard(applicationId, offerid) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/SignCreditCard',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"applicationId":applicationId , "creditCardOfferId ":offerid
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function UncompletedApplications(shopId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/UncompletedApplications',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"shopId":shopId}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function NeedScansApplications(shopId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Status/NeedScansApplications',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"shopId":shopId}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

		
		 function ChangePhoneNumberSendMessage(phone, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + "User/ChangePhoneNumberSendMessage",
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"phone":phone, "token":token}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        function ChangePhoneNumberSendCode (code, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.url + "User/ChangePhoneNumberSendCode",
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"code":code, "token":token}
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function CreateInsurancePolis (data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.url + "Insurance/CreateInsurancePolis",
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: data
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function SendSMSforSignPL(appId){
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url+ '/PayLate/GetSmsCode',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "AppId":appId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function CheckSMSforSignPL(appId, smscode){
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url+'/PayLate/CheckSmsCode',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "AppId":appId,
                    "SmsCode":smscode,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function SMSSignApplication(applicationId, bankId){
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SMSSignApplication',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        /** @description Отправка смс кода по заявке
         *  @param {number} appId - номер заявки в ЦУОКе.(при сопд отсылается номер черновика)
         *  @param {number} bankId - ид банка (при сопд отсылается 0)
         *  @param {number} smsType - тип отправляемого смс (1 - ПЭП, 2 - Подписание, 4- CОПД)
         */
        function SendSMSforSign(appId, bankId, smsType){
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url+ 'Banks/SendSms',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId":appId,
                    "bankId": bankId,
                    "smsType": smsType,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        /** @description Проверка смс кода по заявке
         *  @param {number} appId - номер заявки в ЦУОКе.
         *  @param {number} bankId - ид банка.
         *  @param {number} smsType - тип отправляемого смс (1 - ПЭП, 2 - Подписание,4- сопд)
         *  @param {string} smsCode - код смс для проверки
         */
        function CheckSMSforSign(appId, bankId, smsType, smsCode){
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url+ 'Banks/CheckSms',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId":appId,
                    "bankId": bankId,
                    "smsType": smsType,
                    "smsCode": smsCode,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function SendAuthorizationCode(applicationId, bankId, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SendAuthorizationCode',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "applicationId": applicationId,
                    "bankId": bankId,
                    "token": token
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
        function SendSubscribe(token, Surname, Name, Patronymic, clientPhone,subscribeId, clientEmail ) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Banks/SendToIVIByCash',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {
                    "token":token,
                    "Surname":Surname,
                    "Name":Name,
                    "Patronymic":Patronymic,
                    "clientPhone":clientPhone,
                    "subscriptionServiceId":subscribeId,
                    "email":clientEmail
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        $rootScope.openModalWithNotCloseApplication(true, true).then(function(response){
                            var promiseObj = $timeout(function(){
                                QueryLoader.init('session_end');
                            }, 5000);
                        }).error(function(response){QueryLoader.init('session_end');});
                        // QueryLoader.init('session_end');
                    }
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }


        return informationServices;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('ServicesKOKladr', ServicesKOKladr);

    ServicesKOKladr.$inject = ['$http', '$cookieStore', '$rootScope', '$timeout', 'apiHost', '$q'];
    function ServicesKOKladr($http, $cookieStore, $rootScope, $timeout, apiHost, $q) {
        var kladrko = {};
        kladrko.getKLADR = getKLADR;
        kladrko.getKLADRSprav = getKLADRSprav;
        function getKLADR(string) {
            var deferred = $q.defer();
            var req = {
                method: 'GET',
                url:apiHost.klardurl + 'KLADRSService.svc/KLADR?' + string,
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")

                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );

            return deferred.promise;
        }

        function getKLADRSprav(string) {
            var deferred = $q.defer();
            var req = {
                method: 'GET',
                url:apiHost.klardurl + 'KLADRSService.svc/KLADRSprav?' + string,
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );

            return deferred.promise;
        }

        return kladrko;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('AuthenticationService', AuthenticationService);

    AuthenticationService.$inject = ['$http', '$cookieStore', '$rootScope', '$timeout', 'apiHost', '$q'];
    function AuthenticationService($http, $cookieStore, $rootScope, $timeout, apiHost, $q) {
        var service = {};

        service.Login = Login;
        service.forgetPassword = forgetPassword;
        service.sendInputValueForCodeTT = sendInputValueForCodeTT;
        service.sendCodeTTonServices = sendCodeTTonServices;
        service.AuthorizationWithUserId = AuthorizationWithUserId;
        service.AuthorizationBeeline = AuthorizationBeeline;


            return service;

        function Login(UserLogin) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'User/Authorization',
                headers: {
                },
                data: UserLogin
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }

            );

            return deferred.promise;
        }

        function sendCodeTTonServices(code, token) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'User/AuthorizationWithTT',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"code":code,
                       "token": token}
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }

            );

            return deferred.promise;
        }

        function forgetPassword(information) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'User/ForgetPassword',
                headers: {
                },
                data: {"contact":information}
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }

            );

            return deferred.promise;
        }
        
        function sendInputValueForCodeTT(value, token) {
            var deferred = $q.defer();

            var req = {
                method: 'POST',
                url: apiHost.url + 'User/TakePointOrganization',
                headers: {
                },
                data:  
                {"value":value,
                "token": token}
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }

            );

            return deferred.promise;
        }

        function AuthorizationWithUserId(userId, shopId, accessToken ) {
            var deferred = $q.defer();

            var req = {
                method: 'POST',
                url: apiHost.url + 'User/AuthorizationWithUserId',
                headers: {
                },
                data:
                    {"userId":userId, "shopId": shopId, "accessToken":accessToken }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }

            );

            return deferred.promise;
        }

        function AuthorizationBeeline(accessTokenString ) {
            var deferred = $q.defer();

            var req = {
                method: 'POST',
                url: apiHost.url + 'User/AuthorizationBeeline',
                headers: {
                },
                data:
                    {"accessTokenString":accessTokenString }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }

            );

            return deferred.promise;
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('GetReference', GetReference);

    GetReference.$inject = ['$http', '$cookieStore', '$rootScope', '$timeout', 'apiHost', '$q'];
    function GetReference($http, $cookieStore, $rootScope, $timeout, apiHost, $q) {
        var reference = {};

        reference.TypeCredit = TypeCredit;
        reference.InitialPayment = InitialPayment;
        reference.PeriodCredit = PeriodCredit;
        reference.InsuranceAndBox = InsuranceAndBox;
        reference.SmsPackage = SmsPackage;

        reference.CategoriesProduct = CategoriesProduct;
        reference.GoodTypesAndCategoriesInsurance = GoodTypesAndCategoriesInsurance;
        reference.GetRefuseCodes = GetRefuseCodes;

        reference.Dictionary = Dictionary;
        reference.ShowClientInfo = ShowClientInfo;
        reference.ReasonsNextBank = ReasonsNextBank;

        function TypeCredit(CreditType, InstallmentPlanType) {
            var deferred = $q.defer();
            var creditDictionary = [];
            var creditDictionaryShort = [];
            if(CreditType){
                creditDictionary.push({type:true, value:"Кредит"});
                creditDictionaryShort.push({type:"true", value:"Кредит"});
            }
            if(InstallmentPlanType){
                creditDictionary.push({type:false, value:"Рассрочка"});
                creditDictionaryShort.push({type:"false", value:"Рассрочка"})
            }
            if(!CreditType && !InstallmentPlanType){
                creditDictionary = [
                    {type:true, value:"Кредит"},
                    {type:false, value:"Рассрочка"}
                ];

                creditDictionaryShort =  [
                    {type:"true", value:"Кредит"},
                    {type:"false", value:"Рассрочка"}
                ];
            }

            var data = {
                isSuccess: true,
                description: creditDictionary,
                descriptionShort: creditDictionaryShort
            };
            deferred.resolve(data);
            return deferred.promise;
        }

        function InitialPayment(organizationId, sumGoods, isCredit, shopId,tempApplicationId, term) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/InitialPayment ',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data:{
                    "organizationId":organizationId,
                    "sumGoods":sumGoods,
                    "isCredit":isCredit,
                    "shopId":shopId,
                    "tempApplicationId": tempApplicationId,
                    "term":term
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );


            return deferred.promise;
        }

        function PeriodCredit(organizationId, sumGoods, isCredit, initialPayment, shopId, tempApplicationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/Term ',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data:{
                    "organizationId":organizationId,
                    "sumGoods":sumGoods,
                    "isCredit":isCredit,
                    "initialPayment":initialPayment,
                    "shopId":shopId,
                    "tempApplicationId": tempApplicationId
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            return deferred.promise;
        }

        function SmsPackage() {
            var deferred = $q.defer();

            var data = {
                isSuccess: true,
                description: [
                    {type: true, value:"да"},
                    {type: false, value:"нет"}
                ]
            };
            deferred.resolve(data);
            return deferred.promise;
        }

        function InsuranceAndBox(organizationId, shopId, sumGoods) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/AdditionalServices',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data:{
                    "organizationId": organizationId,
                    "shopId":shopId,
                    "sumGoods":sumGoods
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );


            return deferred.promise;
        }

        function CategoriesProduct(organizationId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Application/GoodTypesAndCategories  ',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data:{
                    "organizationId":organizationId
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        QueryLoader.init('session_end');
                    }
                }
            );



            return deferred.promise;
        }

        function GoodTypesAndCategoriesInsurance(shopId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.url + 'Insurance/GoodTypesAndCategoriesInsurance ',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data:{
                    "shopId":shopId
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    if(error.status == 401){
                        QueryLoader.init('session_end');
                    }
                }
            );



            return deferred.promise;
        }

        function GetRefuseCodes() {
            var deferred = $q.defer();
            var req = {
                method: 'GET',
                url: apiHost.url + 'Draft/GetRefuseCodes',
                headers: {
                    Authorization :localStorage.getItem("token")
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            return deferred.promise;
        }

        function Dictionary(method) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:  apiHost.url + 'Application/Dictionary',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: {"dictName":method}
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            return deferred.promise;
        }

        function ShowClientInfo(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:  apiHost.url + 'Application/ShowClientInfo',
                headers: {
                    Authorization :localStorage.getItem("token")
                },
                data: data
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            return deferred.promise;
        }

        function ReasonsNextBank() {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:  apiHost.url + 'Status/Reasons',
                headers: {
                    Authorization :localStorage.getItem("token")
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            return deferred.promise;
        }

        return reference;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('MicroServices', MicroServices);

    MicroServices.$inject = ['$http', '$cookieStore', '$rootScope', '$timeout', 'apiHost', '$q'];
    function MicroServices($http, $cookieStore, $rootScope, $timeout, apiHost, $q) {
        var microservices = {};

        microservices.getGender = getGender;
        microservices.getIssuedBy = getIssuedBy;
        microservices.getKLADR = getKLADR;
        microservices.GetOrgDaData = GetOrgDaData;
        microservices.GetCountWorkerDaData=GetCountWorkerDaData;
        microservices.getPosition=getPosition;
        microservices.getAutoMarks=getAutoMarks;
        microservices.getAutoModels=getAutoModels;
        //var service_url='https://new.cpoint.ru/Services/AutoComplete/api/Main/';
        function getGender(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: apiHost.autocompliteurl + 'GetFioDaData',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "fio": data
                }
            };

            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );


            return deferred.promise;
        }

        function getIssuedBy(timeBy, specCode) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.autocompliteurl + 'PassportIssuer',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "divisionCode": specCode,
                    "issueDate": timeBy
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            
            return deferred.promise;
        }
        
        function getKLADR(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.autocompliteurl + 'GetAddressDaData',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "addressString": data
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            
            return deferred.promise;
        }

        function GetOrgDaData(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
               // url:apiHost.autocompliteurl + 'GetOrgDaData',
                url:apiHost.autocompliteurl + 'GetAdditionalOrgDaData',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "query": data
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );

            return deferred.promise;
        }
        function GetCountWorkerDaData(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.autocompliteurl + 'GetOrgDaDataByInnOrOgrn',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "query": data,
                    "branch_type": "MAIN",
                    "type": "LEGAL"
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );

            return deferred.promise;
        }
        function getPosition(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.autocompliteurl + 'GetPosition',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "query": data
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );

            return deferred.promise;
        }
        function getAutoMarks(data) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.url + 'Application/AutoMarks',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "organizationId": 0,
                    "name": data
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );

            return deferred.promise;
        }
        function getAutoModels(data,markId) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url:apiHost.url + 'Application/AutoModels',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization':localStorage.getItem("token")
                },

                data: {
                    "organizationId": 0,
                    "name": data,
                    "markId": markId
                }
            };
            $http(req).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.resolve(error);
                }
            );

            return deferred.promise;
        }


        return microservices;
    }
})();
/**
 * Created by lovjagina on 25.08.2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .factory('AnimationShowText', AnimationShowText);

    AnimationShowText.$inject = ['$rootScope'];
    function AnimationShowText($rootScope) {
        function showText(text, timeforfadeout) {
            $('.popup-error').html(text).show();
            (!timeforfadeout)?$('.popup-error'):$('.popup-error').fadeOut(timeforfadeout);
        }
        function cleanText() {
            $('.popup-error').hide();
        }
            return {
                showText: showText,
                cleanText:cleanText};
        };
    })();